export enum KeyboardKeys {
  "MOVE_UP" = "up",
  "ESCAPE" = "esc",
  "ENTER" = "enter",
  "MOVE_DOWN" = "down",
  "TAB" = "tab",
  "BACK_SLASH" = "/",
}
